<template>
  <div class="scheduleDetail_inforPanel">
    <span class="detailInfor_left">
      <span class="detailInfor_left_colum1">
        <span class="logoSpan">
          <img :src="paramsItem.logo" />
        </span>
        <span
          class="logoName"
          v-text="_valPerFormatHandler(paramsItem.id)"
        ></span>
      </span>
      <span
        class="detailInfor_left_colum2"
        v-text="_valPerFormatHandler(paramsItem.name)"
      ></span>
    </span>
    <span class="detailInfor_right">
      <span class="detailInfor_right_row1">
        <span
          class="playerInfor"
          v-text="`运动员：${_valPerFormatHandler(matchInfor.acnt)}`"
        ></span>
        <span
          class="sportsInfor"
          v-text="`参赛项目：${_valPerFormatHandler(matchInfor.dcnt)}`"
        ></span>
      </span>
      <span class="detailInfor_right_row2">
        <span class="medalItem">
          <span class="medalItem_icon gold"></span>
          <span
            class="medalItem_num"
            v-text="_valPerFormatHandler(matchInfor.gold)"
          ></span>
        </span>
        <span class="medalItem">
          <span class="medalItem_icon silver"></span>
          <span
            class="medalItem_num"
            v-text="_valPerFormatHandler(matchInfor.silver)"
          ></span>
        </span>
        <span class="medalItem">
          <span class="medalItem_icon bronze"></span>
          <span
            class="medalItem_num"
            v-text="_valPerFormatHandler(matchInfor.bronze)"
          ></span>
        </span>
        <span
          class="totalNum"
          v-text="`总：${_valPerFormatHandler(matchInfor.medal)}`"
        ></span>
      </span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'scheduleDetail_inforPanel',
  mixins: [cup_base_data_mixin],
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        gold: '',
        silver: '',
        bronze: '',
        medal: '',
        acnt: '',
        dcnt: '',
      }),
    },
    paramsItem: {
      type: Object,
      default: () => ({
        name: '',
        id: '',
        logo: '',
      }),
    },
    matchEventList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    showTipBtn(item) {
      console.debug('eventItemShowTipClickEvent')
      this.$emit('eventItemShowTipClickEvent', item)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.scheduleDetail_inforPanel {
  height: 12.36vw;
  width: 100%;
  padding-top: 3.125vw;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .detailInfor_left {
    width: 55.55vw;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    .detailInfor_left_colum1 {
      width: 8.68vw;
      height: 3.33vw;
      padding: 0.2778vw;
      background-color: var(--mixtmt_greyColor9);
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .logoSpan {
        width: 4.166vw;
        height: 2.778vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .logoName {
        width: calc(100% - 4.166vw);
        text-align: center;
        font-size: 1.38vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
      }
    }
    .detailInfor_left_colum2 {
      width: calc(100% - 8.68vw);
      padding-left: 0.694vw;
      font-size: 2.083vw;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .detailInfor_right {
    width: calc(100% - 55.55vw);
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex-direction: column;
    .detailInfor_right_row1 {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      color: var(--mixtmt_whiteColor);
      .sportsInfor,
      .playerInfor {
        line-height: 2.778vw;
        font-size: 1.11vw;
        font-weight: bold;
      }
      .sportsInfor {
        padding-left: 2.778vw;
      }
    }
    .detailInfor_right_row2 {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      color: var(--mixtmt_whiteColor);
      .totalNum {
        padding-left: 2.083vw;
        width: auto;
        font-size: 1.11vw;
        font-weight: bold;
      }
      .medalItem {
        padding-left: 2.083vw;
        width: 4.86vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .medalItem_icon {
          width: 1.81vw;
          height: 1.81vw;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          &.gold {
            background-image: var(--mixtmt_gold_num_icon);
          }
          &.silver {
            background-image: var(--mixtmt_silver_num_icon);
          }
          &.bronze {
            background-image: var(--mixtmt_bronze_num_icon);
          }
        }
        .medalItem_num {
          width: calc(100% - 1.81vw);
          text-align: center;
          font-size: 1.11vw;
          font-weight: bold;
        }
      }
    }
  }
}

.mixtmt_pc .scheduleDetail_inforPanel {
}
</style>
